import PreviewPromotionChallenge from './PreviewPromotionChallenge'
import withPreviewPromotionChallenge from './withPreviewPromotionChallenge'

const Connected = withPreviewPromotionChallenge(PreviewPromotionChallenge)

export { Connected as PreviewPromotionChallenge }
